import Head from 'next/head';

const GLOBAL_SUFFIX = 'Stably';

// Wasn't able to to get env vars to work instead here
const isLocalhost = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export function HeadTitle({ title, metric, suffix }: { title?: string; metric?: string; suffix?: string }) {
  const titlePrefix = isLocalhost() ? '[dev] ' : '';
  const fullSuffix = suffix ? ` | ${suffix}` : '';
  const fullMetric = metric ? `: ${metric}` : '';

  // [dev] Title: Metric | Suffix | Stably
  // See layout image: https://github.com/stablyai/noqa/pull/864
  const fullTitle = `${titlePrefix}${title}${fullMetric}${fullSuffix} | ${GLOBAL_SUFFIX}`;

  return (
    <Head>
      {/* We make sure suffix and metric aren't shown before the title */}
      <title>{title ? fullTitle : GLOBAL_SUFFIX}</title>
    </Head>
  );
}
